import * as Yup from "yup";

export const editUserMasterValidation = Yup.object().shape({
  userName: Yup.string().required("userName is required"),
  // userGroupCode: Yup.string().required("userGroupCode is required"),
  // password: Yup.string().required("Password is required"),
  // isActive: Yup.bool(),
});

export const userMasterValidation = Yup.object().shape({
  userID: Yup.mixed().notRequired(),
  userName: Yup.string().required("userName is required"),
  userGroupCode: Yup.string().required("userGroupCode is required"),
  password: Yup.string().when("userID", {
    is: (id) => id === "0" || id === 0,
    then: (schema) => schema.required("Password is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  emailId: Yup.string()
    .email("Enter valid email id")
    .required("Email is required"),
  isActive: Yup.bool().required("isActive is required"),
  isLock: Yup.bool().default(false),
  lastLoginLocation: Yup.string().nullable(),
  appPin: Yup
    .string()
    .required("Please enter app pin")
    .matches(/^[0-9]{4}$/, "PIN must be exactly 4 digits"),

  accessCompanies: Yup.array()
    .of(Yup.number().integer())
    .min(1, "Select at least one company")
    .required("Select at least one company"),
});

export const userGroupValidation = Yup.object().shape({
  userGroupCode: Yup.string().required("user Group Code is required"),
  userGroupName: Yup.string().required("user Group Code is required"),
});
